import PropTypes from 'prop-types';

export default function Link({ blank = false, children, classes = [], href = '', onClick = () => {}, small = false, testId = '' }) {
	const props = {};

	// Classes
	const classNames = ['link', ...classes];
	small && classNames.push('link--small');
	props.className = classNames.join(' ');

	if (testId) {
		props['data-testid'] = testId;
	}

	if (href) {
		props.href = href;
		props.target = blank ? '_blank' : '_self';
		if (blank) {
			props.rel = 'noopener noreferrer';
		}
	} else if (onClick) {
		props.onClick = onClick;
	}

	return href ? <a {...props}>{children}</a> : <button {...props}>{children}</button>;
}

Link.propTypes = {
	blank: PropTypes.bool,
	children: PropTypes.node,
	classes: PropTypes.array,
	href: PropTypes.string,
	onClick: PropTypes.func,
	small: PropTypes.bool,
	testId: PropTypes.string,
};
